

















































































import Vue from 'vue';
import { getContentArea } from '@/contentful';
import moment from 'moment';
import { dialogMaxWidth, dateFormat } from '@/constants';
import { PageIntro, PageSidebar } from '@/components/page-components';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { taxDocs, TAX_DOCS_API_SUB_URLS } from '@/api';
import {
  MemberAccountResponseModel,
  TaxYearStatement,
  TaxYearsResponseModel,
} from '@/@types/member';

interface Data {
  isLoading: boolean;
  statement5498: string;
  statement1099: string;
  sidebarHeading: string;
  sidebarContent: string;
  taxDocsYears: string;
  settings1099: {
    route: () => string;
    loading: boolean;
    filename: () => string;
    extension: string;
  };
  settings5498: {
    route: () => string;
    loading: boolean;
    filename: () => string;
    extension: string;
  };
  currentSettings: null;
  errorDownloading: boolean;
  dialogMaxWidth: string;
}

export default Vue.extend({
  name: 'TaxForms',
  beforeRouteEnter(to, from, next) {
    const isHSA =
      store.getters.currentAccount(to.params.id).productType === 'HSA';
    const promises = [getContentArea('tax-forms-sidebar-content')];

    if (isHSA) {
      promises.push(store.dispatch('getMemberTaxStatementYears'));

      const TAX_YEARS_PROMISE = taxDocs
        .get(`${TAX_DOCS_API_SUB_URLS.taxYears}`)
        .then((taxDocsYears) => {
          if (taxDocsYears && taxDocsYears.data) {
            to.meta.taxDocsYears = taxDocsYears.data;
          } else {
            to.meta.taxDocsYears = {};
            // For screenshots
            // to.meta.taxDocsYears = {
            //   '1099-SA': '2019,2018,2017',
            //   '5498-SA': '2019,2018,2017',
            // };
          }
        });
      promises.push(TAX_YEARS_PROMISE);
    }

    LoadingService.watchPromises(promises)
      .then((data) => {
        const sidebar = data[0];
        if (sidebar && sidebar.fields) {
          to.meta.sidebarHeading = sidebar.fields.headline;
          to.meta.sidebarContent = sidebar.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      isLoading: false,
      statement5498: '',
      statement1099: '',
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      taxDocsYears: this.$route.meta.taxDocsYears,
      settings1099: {
        route: () => '',
        loading: false,
        filename: () => '',
        extension: '.pdf',
      },
      settings5498: {
        route: () => '',
        loading: false,
        filename: () => '',
        extension: '.pdf',
      },
      currentSettings: null,
      errorDownloading: false,
      dialogMaxWidth,
    };
  },
  beforeMount() {
    this.settings1099 = {
      route: () => this.taxStatement1099Route,
        loading: false,
        filename: () => this.taxStatement1099Filename,
        extension: '.pdf',
    };
    this.settings5498 = {
      route: () => this.taxStatement5498Route,
        loading: false,
        filename: () => this.taxStatement5498Filename,
        extension: '.pdf',
    };
  },
  computed: {
    hasTaxForms(): number {
      return (
        (this.taxStatement1099Options && this.taxStatement1099Options.length) ||
        (this.taxStatement5498Options && this.taxStatement5498Options.length)
      );
    },
    isHSA(): boolean {
      return (
        this.$store.getters.currentAccount(this.$route.params.id)
          .productType === 'HSA'
      );
    },
    taxStatementYears(): TaxYearsResponseModel {
      return this.$store.getters.memberTaxStatementYears;
    },
    taxDocs1099(): string[] {
      return this.taxDocsYears['1099-SA'] || [];
    },
    taxDocs5498(): string[] {
      return this.taxDocsYears['5498-SA'] || [];
    },
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    taxStatement1099Options(): TaxYearStatement[] {
      if (this.taxStatementYears.taxStatement1099) {
        return this.taxStatementYears.taxStatement1099.filter((statement) => {
          const isInTaxDocYears =
            this.taxDocs1099.indexOf(statement.taxYear) > -1;
          return (
            statement.isVisible &&
            statement.taxYear >=
              moment(this.account.startDate, dateFormat).format('YYYY') &&
            statement.taxYear <=
              moment(this.account.endDate, dateFormat).format('YYYY') &&
            isInTaxDocYears
          );
        });
      }

      return [];
    },
    taxStatement5498Options(): TaxYearStatement[] {
      if (this.taxStatementYears.taxStatement5498) {
        return this.taxStatementYears.taxStatement5498.filter((statement) => {
          const isInTaxDocYears =
            this.taxDocs5498.indexOf(statement.taxYear) > -1;
          return (
            statement.isVisible &&
            statement.taxYear >=
              moment(this.account.startDate, dateFormat).format('YYYY') &&
            statement.taxYear <=
              moment(this.account.endDate, dateFormat).format('YYYY') &&
            isInTaxDocYears
          );
        });
      }

      return [];
    },
    taxStatement1099Route(): string {
      return `${TAX_DOCS_API_SUB_URLS.request1099}?year=${this.statement1099}`;
    },
    taxStatement5498Route(): string {
      return `${TAX_DOCS_API_SUB_URLS.request5498}?year=${this.statement5498}`;
    },
    taxStatement1099Filename(): string {
      return `form-1099-${this.statement1099}.pdf`;
    },
    taxStatement5498Filename(): string {
      return `form-5498-${this.statement5498}.pdf`;
    },
  },
  methods: {
    downloadForm(settings): void {
      settings.loading = true;
      taxDocs
        .get(settings.route(), { responseType: 'blob' })
        .then((response) => {
          const link = document.createElement('a');

          // Edge
          if (window.Navigator.msSaveOrOpenBlob) {
            const newBlob = new Blob(response.data);
            window.Navigator.msSaveOrOpenBlob(
              newBlob,
              settings.filename() + settings.extension,
            );
          } else if (window.navigator.msSaveOrOpenBlob) {
            // IE11
            const newBlob = new Blob([response.data], {
              type: response['content-type'],
            });
            window.navigator.msSaveOrOpenBlob(
              newBlob,
              settings.filename() + settings.extension,
            );
          } else {
            // Everything else
            link.href = window.URL.createObjectURL(response.data);
          }

          link.download = settings.filename();
          document.body.appendChild(link);
          link.click();
          link.remove();
          settings.loading = false;
        })
        .catch(() => {
          settings.loading = false;
          this.currentSettings = settings;
          this.errorDownloading = true;
        });
    },
    tryFormDownloadAgain(): void {
      this.errorDownloading = false;
      this.downloadForm(this.currentSettings);
    },
    dismissFormDownloadError(): void {
      this.errorDownloading = false;
    },
  },
  components: {
    PageIntro,
    PageSidebar,
  },
});
